import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeCertRenewUrl = `${id_netscapeCertExtension}.7`;
let NetscapeCertRenewUrl = class NetscapeCertRenewUrl {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeCertRenewUrl.prototype, "value", void 0);
NetscapeCertRenewUrl = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeCertRenewUrl);
export { NetscapeCertRenewUrl };
